import React from 'react';
import axios from 'axios';
import get from 'lodash/get';
import { withFormik } from 'formik';

import { Button } from '@lightspeed/flame/Button';
import Group from '@lightspeed/cirrus-group';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/cirrus-modal';
import Text from '@lightspeed/cirrus-text';

const EnableAccountModal = ({ handleSubmit, isSubmitting, onClose }) => (
  <Modal className="cirrus" isOpen onRequestClose={() => onClose()}>
    <ModalHeader onCloseClicked={() => onClose()}>Enable eCom Integration</ModalHeader>
    <ModalBody>
      <Text body color="gray">
        <strong>WARNING</strong>: The eCom subscription must be activated by sales-ops to re-enable
        the integration.
      </Text>
    </ModalBody>
    <ModalFooter>
      <Group className="cr-justify-end">
        <Button onClick={() => onClose()}>Cancel</Button>
        <Button variant="secondary" fill loading={isSubmitting} onClick={handleSubmit}>
          I understand. Enable eCom Integeation
        </Button>
      </Group>
    </ModalFooter>
  </Modal>
);

const enhancedEnableAccountModal = withFormik({
  handleSubmit: async (values, formikBag) => {
    formikBag.setSubmitting(true);

    const { accountId, integrationId } = formikBag.props;

    try {
      await axios.put(`/staff/accounts/${accountId}/integration/${integrationId}/enable`);
      formikBag.props.onConfirm({ updateData: true, message: 'Enable Account pushed to queue' });
    } catch (e) {
      window.alertUser(get(e, 'response.data.errors[0].detail') || 'An error occurred');
    }

    formikBag.setSubmitting(false);
    formikBag.props.onClose();
  },
})(EnableAccountModal);

export default enhancedEnableAccountModal;
